<!-- Displays a contained overlay with a station selector to select the via/avoid station for the journey search. Updates the via/avoid type and station in the journey store directly.
@emit close - Emits when the done button is clicked. -->
<script setup lang="ts">
import { useJourneyStore } from "@/stores/journey-store";
import { ViaAvoidType } from "@/models/ViaAvoidType";
import StationPicker from "@/components/1-JourneyPlanner/StationPicker.vue";

const store = useJourneyStore();
const emit = defineEmits(["close"]);
</script>

<template>
    <v-overlay :model-value="true" contained class="via-avoid-selection-overlay" scrim="white" opacity="1">
        <v-card class="px-sm-4 py-sm-4" flat>
            <v-card-text>
                <div class="via-avoid-selection-wrapper">
                    <v-select :items="[ViaAvoidType.Via, ViaAvoidType.Avoid]" v-model="store.query.viaAvoid" variant="outlined" density="compact" hide-details label="Type" class="via-avoid-type-picker"></v-select>

                    <StationPicker v-model="store.query.viaAvoidStation" placeholder="Select station" class="via-avoid-station-picker mt-5" label="Station"> </StationPicker>

                    <v-btn @click="emit('close')" class="w-100 text-white mt-5" variant="flat" color="var(--vt-c-orange)">Done</v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-overlay>
</template>

<style scoped lang="scss">
.via-avoid-selection-overlay > :deep(.v-overlay__content) {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.via-avoid-selection-overlay > .v-overlay__content > .v-card {
    width: 85%;
}

.via-avoid-selection-wrapper .via-avoid-station-picker,
.via-avoid-selection-wrapper .via-avoid-type-picker {
    flex-basis: 100%;
}

.via-avoid-selection-wrapper {
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    flex-wrap: wrap;
    min-width: 80%;
}

@media (max-width: 600px) {
    .via-avoid-selection-overlay > .v-overlay__content > .v-card {
        width: 100%;
    }
}
</style>
